import { resolveService } from "@services/service-resolver";
import { mobileTicketService } from "./ticket.mobile-service";
import { mockTicketService } from "./ticket.mock-service";
import type { ITicketService } from "../types";

/**
 * Production: Java mobile API — GET tickets?userId={uid} (QRs base64 included).
 * Mock: local mock data.
 */
export const ticketService: ITicketService = resolveService(
  mobileTicketService,
  mockTicketService,
);
